import { render, staticRenderFns } from "./assetImportLogDetailList.vue?vue&type=template&id=2ca2d5a4&scoped=true"
import script from "./assetImportLogDetailList.vue?vue&type=script&lang=js"
export * from "./assetImportLogDetailList.vue?vue&type=script&lang=js"
import style0 from "./assetImportLogDetailList.vue?vue&type=style&index=0&id=2ca2d5a4&prod&scoped=true&lang=css"
import style1 from "./assetImportLogDetailList.vue?vue&type=style&index=1&id=2ca2d5a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2d5a4",
  null
  
)

export default component.exports